<form [formGroup]="form">
  <ng-container formGroupName="template">
    <ng-container *ngTemplateOutlet="sectionHeader; context: { label: 'header', optional: true }"></ng-container>
    <div formGroupName="header" class="header">
      <p>
        <mat-radio-group
          [disabled]="form.get('template.header.type').disabled"
          [value]="headerType"
          (change)="headerTypeChanged($event)"
          class="header-type">
          <mat-radio-button *ngFor="let type of ['text', 'media']" [value]="type">
            <strong
              [attr.data-testid]="'header-type-' + type"
              [translate]="
                'parameters/whatsapp-templates/content/header/choice-' +
                (limitedTimeOfferEnabled && type === 'text' ? 'no-header' : type)
              "></strong>
          </mat-radio-button>
        </mat-radio-group>
      </p>

      <div class="header-text">
        <ng-container *ngIf="headerType === 'text'; else mediaTypeHeader">
          <mat-form-field *ngIf="!limitedTimeOfferEnabled">
            <mat-label [translate]="'parameters/whatsapp-templates/content/header/text'"></mat-label>
            <input #headerText matInput formControlName="text" [maxlength]="limitations.maxLength.header" />
            <span class="text-muted" matSuffix
              >{{ headerText.value?.length || 0 }}/{{ limitations.maxLength.header }}</span
            >
          </mat-form-field>
        </ng-container>
      </div>

      <ng-template #mediaTypeHeader>
        <app-whatsapp-template-media-header
          [form]="$any(form.get('template.header'))"></app-whatsapp-template-media-header>
      </ng-template>
    </div>
    <div class="limited-time-offer">
      <mat-checkbox [formControl]="$any(form.get('template.limitedTimeOfferEnabled'))">
        <span translate="parameters/whatsapp-templates/content/body/limited-time-offer/enabled"></span>
      </mat-checkbox>

      <div [formGroup]="$any(form.get('template.limited_time_offer'))">
        <mat-form-field>
          <mat-label translate="parameters/whatsapp-templates/content/body/limited-time-offer/text"></mat-label>
          <input #textLTO matInput [maxlength]="limitations.maxLength.textLTO" formControlName="text" />
          <span class="text-muted" matSuffix>{{ textLTO.value?.length || 0 }}/{{ limitations.maxLength.textLTO }}</span>
        </mat-form-field>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="sectionHeader; context: { label: 'body' }"></ng-container>
    <p class="body">
      <mat-form-field appearance="outline">
        <textarea
          #bodyText
          matInput
          data-testid="template-text"
          formControlName="body"
          [maxlength]="bodyLTOMaxlength || limitations.maxLength.body"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="3"></textarea>
        <span class="text-muted" matSuffix
          >{{ bodyText.value?.length || 0 }}/{{ bodyLTOMaxlength || limitations.maxLength.body }}</span
        >
        <mat-error
          *ngIf="body.hasError('tooManyPlaceholders')"
          [translate]="'parameters/whatsapp-templates/content/body/placeholders/errors'"
          [translateParams]="{ i: limitations.maxNumber.placeholders }">
        </mat-error>
        <mat-hint
          data-testid="template-description"
          translate="parameters/whatsapp-templates/content/body/placeholders/hint"></mat-hint>
      </mat-form-field>
    </p>
    <div class="placeholders-container" *ngIf="placeholdersControls?.length" formGroupName="placeholders">
      <p
        class="description"
        data-testid="template-description"
        [translate]="'parameters/whatsapp-templates/content/body/placeholders/description'"></p>
      <p *ngFor="let placeholder of placeholdersControls; index as i" formGroupName="{{ placeholder }}">
        <mat-form-field>
          <mat-label
            [attr.data-testid]="'placeholder-label-' + i"
            [translate]="'parameters/whatsapp-templates/content/body/placeholders/label'"
            [translateParams]="{ i: placeholder }"></mat-label>
          <input [attr.data-testid]="'placeholder-input-' + i" matInput formControlName="label" />
        </mat-form-field>
        <mat-form-field>
          <mat-label
            [translate]="'parameters/whatsapp-templates/content/body/placeholders/example'"
            [translateParams]="{ i: placeholder }"></mat-label>
          <input matInput formControlName="example" />
        </mat-form-field>
      </p>
    </div>
    <ng-container *ngTemplateOutlet="sectionHeader; context: { label: 'footer', optional: true }"></ng-container>
    <p class="footer">
      <mat-form-field>
        <mat-label [translate]="'parameters/whatsapp-templates/content/footer/text'"></mat-label>
        <input #footerText matInput formControlName="footer" [maxlength]="limitations.maxLength.footer" />
        <span class="text-muted" matSuffix>{{ footerText.value?.length || 0 }}/{{ limitations.maxLength.footer }}</span>
      </mat-form-field>
    </p>

    <ng-container *ngTemplateOutlet="sectionHeader; context: { label: 'buttons', optional: true }"></ng-container>
    <ng-container *ngIf="form.enabled">
      <p class="text-muted" [translate]="'parameters/whatsapp-templates/content/buttons/description-2'"></p>
    </ng-container>
    <div
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      class="buttons-container"
      [cdkDropListDisabled]="isReadOnly || limitedTimeOfferEnabled"
      [cdkDropListSortPredicate]="sortPredicate">
      <ng-container *ngFor="let section of sections">
        <ng-container
          *ngIf="{
            sectionDisabled: section.type === WhatsappTemplateButtonTypeEnum.COPY_CODE && !isWhatsappCloudAPI
          } as result">
          <div class="sections" cdkDrag [cdkDragData]="section" [class.disabled]="result.sectionDisabled">
            <div class="button-group-title">
              <div
                *ngIf="!isReadOnly"
                class="section-handle"
                [class.d-none]="limitedTimeOfferEnabled || result.sectionDisabled"
                cdkDragHandle>
                <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </div>
              <div class="section-placeholder" *cdkDragPlaceholder></div>

              <mat-icon> {{ section.titleIcon }} </mat-icon>
              <span [translate]="section.titleKey"></span>
            </div>
            <p
              class="track-link-label-description"
              *ngIf="isWhatsappCloudAPI && section.type === WhatsappTemplateButtonTypeEnum.URL">
              <a target="_blank" [href]="trackLinkLabelsManagementUrl">
                <span translate="parameters/whatsapp-templates/content/buttons/track-link-label-description"></span>
                &nbsp;
                <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true">
                  open_in_new
                </mat-icon>
              </a>
            </p>
            <ng-template
              *ngTemplateOutlet="
                buttonsGroupedItemDrag;
                context: { type: section.type, formArray: section.formArray }
              "></ng-template>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</form>

<ng-template #buttonsGroupedItemDrag let-type="type" let-formArray="formArray">
  <div [formGroup]="buttonsGrouped" *ngIf="!isReadOnly || buttonsTypesSet.has(type)">
    <ng-template *ngTemplateOutlet="buttonsGroupedByType; context: { type: type, formArray: formArray }"></ng-template>
    <div class="add-buttons" *ngIf="!isReadOnly">
      <span
        [matTooltipDisabled]="buttonsGrouped.valid"
        [matTooltip]="'parameters/whatsapp-templates/content/buttons/cannot-add-due-to-invalid-button' | translate">
        <mat-icon
          *ngIf="type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY"
          data-testid="add-quick-reply-icon"
          class="add-quick-reply-btn"
          [class.disabled]="cannotAddButton"
          (click)="addQuickReplyButton()">
          add_circle_outline
        </mat-icon>

        <mat-icon
          *ngIf="type === WhatsappTemplateButtonTypeEnum.URL"
          [class.disabled]="cannotAddUrlButton"
          class="add-url-btn"
          (click)="addUrlButton()">
          add_circle_outline
        </mat-icon>

        <mat-icon
          *ngIf="type === WhatsappTemplateButtonTypeEnum.PHONE_NUMBER"
          [class.disabled]="cannotAddPhoneNumberButton"
          class="add-phone-number-btn"
          (click)="addPhoneNumberButton()">
          add_circle_outline
        </mat-icon>

        <mat-icon
          *ngIf="type === WhatsappTemplateButtonTypeEnum.COPY_CODE && isWhatsappCloudAPI"
          [class.disabled]="cannotAddCopyCodeButton"
          class="add-copy-code-btn"
          (click)="addCopyCodeButton()">
          add_circle_outline
        </mat-icon>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #buttonsGroupedByType let-type="type" let-formArray="formArray">
  <div class="button-details" *ngFor="let buttonForm of formArray.controls; let i = index">
    <div *ngIf="type === formArray.controls[i].value.type" class="d-flex">
      <!-- The common field displayed whatever the type is. -->
      <mat-form-field class="button-label">
        <mat-label
          [translate]="'parameters/whatsapp-templates/content/buttons/label'"
          [translateParams]="{ i: i + 1 }"></mat-label>
        <input
          [attr.data-testid]="'button-text-' + i"
          matInput
          [maxlength]="limitations.maxLength.button"
          [formControl]="$any(formArray.controls[i].get('text'))" />
        <mat-icon
          *ngIf="!isReadOnly && !(limitedTimeOfferEnabled && type === WhatsappTemplateButtonTypeEnum.URL && !i)"
          [attr.data-testid]="'remove-button-btn-' + i"
          class="remove-button-btn"
          [class.disabled]="form.disabled"
          matPrefix
          (click)="deleteButton(i, type)">
          remove_circle_outline
        </mat-icon>
        <span class="text-muted" matSuffix>
          {{ formArray.controls[i].get('text').value?.length || 0 }}/{{ limitations.maxLength.button }}
        </span>
      </mat-form-field>

      <!-- The extra field related to the static QR Payload. -->
      <ng-container
        *ngIf="
          formArray.controls[i].value.type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY && agentShortcuts?.length
        ">
        <app-select
          class="button-quick-reply"
          [items]="agentShortcuts"
          [control]="formArray.controls[i].get('payload')"
          [enableTypeahead]="true"
          [labelKey]="'parameters/whatsapp-templates/content/buttons/label/qr-payload'">
        </app-select>
      </ng-container>

      <!-- The extra field related to the URL. -->
      <ng-container *ngIf="formArray.controls[i].value.type === WhatsappTemplateButtonTypeEnum.URL">
        <mat-form-field
          class="button-url"
          *ngIf="{
            urlControl: formArray.controls[i].get('url'),
            exampleControl: formArray.controls[i].get('example')
          } as urlGroup">
          <mat-label
            translate="parameters/whatsapp-templates/content/buttons/label/url"
            [translateParams]="{ i: i + 1 }"></mat-label>
          <input #urlInput matInput [maxlength]="limitations.maxLength.url" [formControl]="$any(urlGroup.urlControl)" />
          <mat-icon matPrefix> open_in_new </mat-icon>
          <span class="text-muted" matSuffix> {{ urlInput.value?.length || 0 }}/{{ limitations.maxLength.url }} </span>
          <mat-hint translate="parameters/whatsapp-templates/content/buttons/label/url/hint"></mat-hint>
        </mat-form-field>

        <mat-form-field *ngIf="urlPlaceholders[formArray.controls[i].getRawValue()?.url]">
          <mat-label
            translate="parameters/whatsapp-templates/content/body/placeholders/example"
            [translateParams]="{ i: 1 }"></mat-label>
          <input #exampleInput matInput [formControl]="$any(formArray.controls[i].get('example'))" />
          <span class="text-muted" matSuffix>
            {{ exampleInput.value?.length || 0 }}/{{ limitations.maxLength.example }}
          </span>
          <mat-hint>{{ getUrlPreview(formArray.controls[i]) }}</mat-hint>
        </mat-form-field>
        <app-select
          *ngIf="urlButtonTrackLinkLabels?.length"
          [class.d-none]="!isWhatsappCloudAPI"
          [items]="urlButtonTrackLinkLabels"
          labelKey="parameters/whatsapp-templates/content/buttons/label/track-link"
          [control]="formArray.controls[i].get('track_link_label_id')"
          [enableTypeahead]="true"></app-select>
      </ng-container>

      <!-- The extra field related to the COPY_CODE. -->
      <ng-container *ngIf="formArray.controls[i].value.type === WhatsappTemplateButtonTypeEnum.COPY_CODE">
        <mat-form-field class="button-copy-code" *ngIf="formArray.controls[i].get('example') as copyCodeControl">
          <mat-label
            translate="parameters/whatsapp-templates/content/buttons/label/copy-code"
            [translateParams]="{ i: i + 1 }"></mat-label>
          <input
            #copyCodeInput
            matInput
            [maxlength]="limitations.maxLength.copyCode"
            [formControl]="$any(copyCodeControl)" />
          <mat-icon matPrefix> content_copy </mat-icon>
          <span class="text-muted" matSuffix>
            {{ copyCodeInput.value?.length || 0 }}/{{ limitations.maxLength.copyCode }}
          </span>
        </mat-form-field>
      </ng-container>

      <!-- The extra field related to the phone number. -->
      <mat-form-field
        floatLabel="always"
        class="button-phone-number"
        [class.mat-form-field-invalid]="formArray.controls[i].get('phone_number').hasError('invalid-number')"
        *ngIf="formArray.controls[i].value.type === WhatsappTemplateButtonTypeEnum.PHONE_NUMBER">
        <mat-label
          [translate]="'parameters/whatsapp-templates/content/buttons/label/phone-number'"
          [translateParams]="{ i: i + 1 }"></mat-label>
        <input hidden matInput [formControl]="$any(formArray.controls[i].get('phone_number'))" />
        <input
          *ngIf="formArray.controls[i].value.type === WhatsappTemplateButtonTypeEnum.PHONE_NUMBER"
          class="tel-input-container"
          #phoneInput
          type="tel"
          matInput
          appTelInput
          [telInputOptions]="{ initialCountry: userLanguage }"
          [telNumber]="telInputInit(i)"
          (blur)="isPhoneNumberButtonValid(i)"
          (telInputChange)="phoneInputChanged($event, i)"
          (intlTelInputObject)="telInputObject($event, i)" />
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- The differents sections (En-tête, Corps, Pied de page, Boutons) -->
<ng-template #sectionHeader let-label="label" let-optional="optional">
  <section>
    <div>
      <span
        [attr.data-testid]="'section-title-' + label"
        [translate]="'parameters/whatsapp-templates/content/' + label + '/title'"></span
      >&nbsp;
      <small
        [attr.data-testid]="'section-optional-' + label"
        *ngIf="optional"
        class="text-muted"
        [translate]="'parameters/whatsapp-templates/content/optional'"></small>
    </div>
  </section>
</ng-template>
